import React, {useEffect, useState} from "react";
import {Select} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useRequiredStore} from "../../../../../../utils/store";
import {observer} from "mobx-react";
import {RootStoreContext} from "../../../../../../stores/root/root.store";
import {userService} from "../../../../../../services/users/user.service";
import {SystemUserAccess} from "../../../../../../models/users/user/system.user";

const buildKey = (accessId: number, branch: string): string => {
    return branch + "|" + accessId;
}

const parseKey = (key: string): {branch: string, accessId: number} => {
    const data = key.split('|')
    return {
        branch: data[0],
        accessId: parseInt(data[1])
    }
}

export const UIInputWidgetDepartment: React.FC<any> = observer(() => {

    const {authStore} = useRequiredStore(RootStoreContext);

    const [accesses, setAccesses] = useState<SystemUserAccess[]>([]);

    useEffect(() => {
        Promise.all(authStore.availableServers.map(server => {
            return userService.getAccesses(server);
        })).then(values => {
            return setAccesses(values.flat())
        })
    }, [authStore.availableServers]);

    const handleChange = (key: string) => {
        const auth = parseKey(key);
        authStore.switch(auth.branch, String(auth.accessId));
    };

    if (accesses.length === 0) {
        return [];
    }

    return (
        <Select<string>
            onChange={key => handleChange(key)}
            style={{ width: "280px" }}
            value={buildKey(authStore.access, authStore.branch)}
            suffixIcon={<FontAwesomeIcon icon={["fas", "building"]} />}
        >
            {accesses.map((item, index) => (
                <Select.Option key={buildKey(item.id, item.branchId)} value={buildKey(item.id, item.branchId)}>
                    {item.branchName}
                </Select.Option>
            ))}
        </Select>
    )
})